module.exports = __webpack_public_path__ + "img/xshoplus.dd52f8dc.svg";